import { Button } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Title } from '@/components_deprecated/Title'
import styled from 'styled-components'

interface ErrorFallbackProps {
  error: Error
  resetErrorBoundary: () => void
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 1rem;
`

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const translations = useTranslate({
    title: 'error.generic-title',
    button: 'error.try-again',
  })
  return (
    <Wrapper role="alert">
      <Title.H2>{translations.title}:</Title.H2>
      <p>{error.message}</p>
      <Button onClick={resetErrorBoundary}>{translations.button}</Button>
    </Wrapper>
  )
}
